import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export function howWork() {
  const swiper = new Swiper('.how-work__swiper', {
    modules: [Navigation, Pagination],
    spaceBetween: 30,
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}
